// extracted by mini-css-extract-plugin
export default {"AppInput":"AppInput_AppInput__cTY52","AppInput__wrapper":"AppInput_AppInput__wrapper__S3cCH","AppInput__currency":"AppInput_AppInput__currency__jWggK"};